import api from '@/api/Api'
import apiWithoutAuth from '@/api/ApiWithoutAuth'
import store from '@state/store'
export const state = {
  types: [],
  taskUpload: [],
  uploading: false,
  listCancel: []
}

export const getters = {
  types (state) {
    return state.types
  },
  taskUpload (state) {
    return state.taskUpload
  }
}

export const mutations = {
  SET_TYPE (state, newValue) {
    state.types = newValue
  },
  SET_STATUS_UPLOAD (state, newValue) {
    if (state.taskUpload.length > 0) {
      let task = state.taskUpload.find(val => val.id === newValue.id)
      if (task) {
        if (!task.cancel) {
          task.cancel = state.listCancel.find(val => val.id === task.id).cancel
        }
        task.percent = newValue.percent
      } else {
        if (newValue.percent !== 100) state.taskUpload.push(newValue)
      }
    } else {
      state.taskUpload.push(newValue)
    }
  },
  SET_CANCEL_UPLOAD (state, newValue) {
    state.listCancel.push(newValue)
  },
  DELETE_STATUS_UPLOAD (state, id) {
    if (id) {
      state.taskUpload = state.taskUpload.filter(val => val.id !== id)
    } else {
      state.taskUpload = state.taskUpload.filter(
        val => val.percent !== 100 || val.error
      )
    }
    if (state.taskUpload.length <= 0) {
      state.uploading = false
    }
  },
  SET_STATUS (state, newValue) {
    state.uploading = newValue
  },
  SET_TASK (state, newValue) {
    state.taskUpload = state.taskUpload.concat(newValue)
  },
  SET_LIST_ERROR (state, id) {
    let ind = state.taskUpload.findIndex(val => val.id === id)
    if (ind >= 0) {
      state.taskUpload[ind].error = true
    }
  }
}
export const actions = {
  afterSelectWorkspace ({ commit, dispatch, rootState }) {
    dispatch('fetchType')
  },
  fetchType ({ commit, state }) {
    return api.getTrainType().then(response => {
      const types = response.data.data
      types.map(type => {
        type.display = `${type.group} (${type.name})`
        return type
      })
      commit('SET_TYPE', types)
      return types
    })
  },
  runTrainingModel ({ commit, state, rootState }, data) {
    let form = data.form
    let payload = {
      labels: form.labels,
      type: form.type,
      image_id: form.image_id,
      name: !form.modelId ? form.name : undefined,
      annotation: form.annotation,
      features: form.features,
      bound: form.bound,
      task_name: form.name,
      mask: form.mask ? form.mask : undefined,
      input_type: form.inputType,
      model_id: form.modelId ? form.modelId : undefined,
      vector_ids: form.vector_ids,
      folder_id: form.folderId,
      version: form.version,
      trainer_id: form.trainerId,
      environment: form.environment
    }
    if (!form.modelId) {
      payload = Object.assign({}, payload, {params: data.config})
    }
    return api.trainingModel(form.workspaceId, payload).then(response => {
      return response
    })
  },

  uploadTrainingFile ({ commit, dispatch, state }) {
    let tmp = state.taskUpload.find(val => !val.error)
    if (tmp) {
      dispatch('uploadTraining', tmp)
        .then(val => {
          if (val) {
            store.dispatch('message/setNotification', {
              type: 'success',
              active: true,
              message: val.data.message ? val.data.message : 'Successful'
            })
          } else {
            store.dispatch('message/setNotification', {
              type: 'error',
              active: true,
              message: `Upload failed`
            })
          }
        })
        .catch(er => {
          commit('SET_LIST_ERROR', tmp.id)
          if (er.status_code === 499) {
            store.dispatch('message/setNotification', {
              type: 'success',
              active: true,
              message: 'Task has been canceled'
            })
          } else {
            store.dispatch('message/setNotification', {
              type: 'error',
              active: true,
              message: er.message ? er.message : 'Task has been canceled'
            })
          }
          commit('SET_STATUS', false)
          let check = state.taskUpload.filter(val => !val.error)
          if (check.length > 0) {
            dispatch('startUpload')
          }
        })
    }
  },
  async uploadTraining ({ commit, state, dispatch }, request) {
    return apiWithoutAuth
      .uploadTrainingS3(request.data)
      .then(response => {
        commit('DELETE_STATUS_UPLOAD')
        dispatch('createTaskUpload', request)
        if (state.taskUpload.length > 0) {
          let tmp = state.taskUpload.find(val => !val.error)
          if (tmp) {
            dispatch('uploadTraining', tmp)
          } else {
            commit('SET_STATUS', false)
          }
        } else {
          commit('SET_STATUS', false)
        }
        return response
      })
      .catch(er => {
        store.dispatch('message/setNotification', {
          type: 'error',
          active: true,
          message: er.message ? er.message : 'Server error'
        })
      })
  },
  createTaskUpload ({ commit, state, dispatch }, data) {
    const tasks = state.taskUpload.filter(
      task => task.taskData.id === data.taskData.id
    )

    if (tasks.length) return

    return api
      .uploadModel(data.taskData.wksId, data.taskData.data)
      .then(val => {
        store.dispatch('message/setNotification', {
          type: 'success',
          active: true,
          message: val.data.message
        })
      })
      .catch(er => {
        store.dispatch('message/setNotification', {
          type: 'error',
          active: true,
          message: er.message ? er.message : 'Server error'
        })
      })
  },
  checkStatusUpload ({ commit, dispatch, state }) {
    const taskCreated = state.taskUpload.find(val => !val.error)
    if (taskCreated) dispatch('uploadTrainingFile', taskCreated)
    else commit('SET_STATUS', false)
  },
  startUpload ({ commit, dispatch, state }, data) {
    if (state.taskUpload.length > 0) {
      commit('SET_STATUS', true)
      dispatch('uploadTrainingFile')
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/training.js